<main class="contact-page">
  <div class="top-row">
    <button type="button" class="back-btn" [attr.aria-label]="'profile.backAria' | translate" (click)="goBack()">
      <sz-icon name="arrow-back" [size]="20" />
    </button>
    <sz-brand-block [compact]="true" />
  </div>

  <div class="contact-head">
    <div class="contact-head__kicker">
      <span>{{ 'contact.kicker' | translate }}</span>
    </div>
    <h1 class="contact-head__title">
      {{ 'contact.titleMain' | translate }}
      <span class="contact-head__accent">{{ 'contact.titleAccent' | translate }}</span>
    </h1>
    <p class="contact-head__intro">{{ 'contact.intro' | translate }}</p>
  </div>

  @if (success()) {
    <div class="contact-success" role="status">
      <sz-icon name="check" [size]="18" />
      <div>
        <div class="contact-success__title">{{ 'contact.success.title' | translate }}</div>
        <div class="contact-success__body">{{ 'contact.success.body' | translate }}</div>
      </div>
    </div>
  }

  <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <div class="field">
      <div class="field__row">
        <span class="field__label">{{ 'contact.field.message' | translate }}</span>
        <span class="field__counter">{{ remainingChars() }}</span>
      </div>
      <textarea
        class="contact-textarea"
        formControlName="message"
        [maxLength]="maxLength"
        [placeholder]="'contact.field.messagePlaceholder' | translate"
        rows="8"></textarea>
    </div>

    @if (errorMessage(); as msg) {
      <p class="contact-error" role="alert">{{ msg }}</p>
    }

    <button
      type="submit"
      class="cta cta--primary"
      [disabled]="loading() || form.invalid"
      [attr.aria-busy]="loading() ? 'true' : null">
      @if (loading()) {
        <span class="spinner" role="status" [attr.aria-label]="'contact.sendingAria' | translate"></span>
      } @else {
        <sz-icon name="mail" [size]="16" />
        <span>{{ 'contact.submit' | translate }}</span>
      }
    </button>
  </form>
</main>
